import { combineReducers } from "redux";
import filterReducer from "./filters/reducer";
import todoReducer from "./todos/reducer";

const rootReducer = combineReducers({
    bookslist: todoReducer,
    filters: filterReducer,
});

export default rootReducer;
